import React, { useState, useMemo } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewAltCard,
  TooltipComponent,
} from "../../../components/Component";
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { Link } from "react-router-dom";
import MyLoader from "../form/MyLoader";
import { UserAvatarCell } from "../../ImagePre/UserAvatarCell";

const SubCategoryTable = ({
  publicButton,
  nameColumn,
  handleImageOpenPreview,
  resetF,
  isOpen,
  setIsOpen,
  title = "Data Table",
  data = [],
  columns = [],
  onEditClick,
  selectorCheck,
  onSelectChange,
  searchKeys,
  statusFilterEnabled = false,
  addButton = true,
  imageBaseURL = "",
  handleToggleStatus,
  toggleCanvas,
  handleTogglePublish,
  isLoading,
  handleSubCategoryClick,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(5);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const [expandedRows, setExpandedRows] = useState({});

  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const filteredData = useMemo(() => {
    let filtered = data;

    if (searchText.trim() !== "" && searchKeys.length > 0) {
      filtered = filtered.filter((item) =>
        searchKeys
          .map((key) => item[key])
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase()),
      );
    }

    if (statusFilterEnabled) {
      if (statusFilter === "active") filtered = filtered.filter((i) => i.status === true);
      else if (statusFilter === "inactive") filtered = filtered.filter((i) => i.status === false);
    }

    return filtered;
  }, [data, searchText, statusFilter]);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderRow = (item, level = 0) => {
    const hasChildren = item.subcategory && item.subcategory.length > 0;
    const isExpanded = expandedRows[item.id];

    return (
      <>
        <DataTableItem key={item.id} className="hover-row align-middle">
          {columns.map((col, index) => {
            const getValue = (obj, path) => path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);

            const value = getValue(item, col.key);

            return (
              <DataTableRow key={col.key}>
                {index === 0 ? (
                  <div className="d-flex align-items-center gap-2" style={{ paddingLeft: `${level * 20}px` }}>
                    {hasChildren ? (
                      <Icon
                        name={isExpanded ? "caret-down" : "caret-right"}
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleExpand(item.id)}
                      />
                    ) : (
                      <Icon name="dot" />
                    )}

                    {col.type === "image" && (
                      <>
                        {/* <img
                          src={`${imageBaseURL}${value}`}
                          onClick={() => handleImageOpenPreview(`${imageBaseURL}${value}`)}
                          alt="img"
                          style={{
                            width: "45px",
                            height: "45px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                        /> */}
                        <UserAvatarCell
                          row={col}
                          image={`${imageBaseURL}${value}`}
                          name={item[nameColumn]}
                          handleImageOpenPreview={() => handleImageOpenPreview(`${imageBaseURL}${value}`)}
                        />
                      </>
                    )}
                    {nameColumn && (
                      <span
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#364a63",
                          textTransform: "capitalize",
                        }}
                      >
                        {item[nameColumn]}
                      </span>
                    )}
                  </div>
                ) : (
                  <span style={{ fontWeight: "450" }}>{value || "-"}</span>
                )}
              </DataTableRow>
            );
          })}
          <DataTableRow className="text-center">
            <span
              onClick={() => handleToggleStatus(item)}
              className={`fw-700 ${item.status ? "text-success" : "text-danger"}`}
              style={{ cursor: "pointer", textTransform: "capitalize" }}
            >
              {item.status ? "Active" : "Inactive"}
            </span>
            {publicButton && (
              <Button
                outline
                color={item?.isPublish ? `warning` : `success`}
                size={`xs`}
                className={`mx-1`}
                onClick={() => handleTogglePublish(item)}
              >
                <Icon name={item?.isPublish ? "inbox-in" : "inbox-out"}></Icon>
              </Button>
            )}
          </DataTableRow>
          <DataTableRow className="text-center">
            <ul className="nk-tb-actions gx-1 justify-content-center">
              {/* <li
                onClick={() => {
                  onEditClick(item);
                }}
                className="edit-icon"
              >
                <TooltipComponent
                  tag="a"
                  containerClassName="btn btn-icon btn-trigger btn-tooltip"
                  id={"edit" + item.id}
                  icon="edit-alt"
                  direction="top"
                  text="Edit"
                  onClick={toggleCanvas}
                />
              </li> */}
              <li>
                <UncontrolledDropdown>
                  <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                  </DropdownToggle>

                  <DropdownMenu end>
                    <ul className="link-list-opt no-bdr">
                      <li onClick={() => onEditClick(item)}>
                        <DropdownItem >
                          {/* <Icon name="eye" />
                          <span className="ms-2">View</span> */}
                          <div
                            tag="a" href="#edit" onClick={(ev) => ev.preventDefault()}
                            outline
                            color="primary"
                            size="s"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Icon name="edit me-1"></Icon>
                            <span>Edit</span>
                          </div>
                        </DropdownItem>
                      </li>

                      <li onClick={() => handleSubCategoryClick(item)}>
                        <DropdownItem>
                          {/* <Icon name="eye" />
                          <span className="ms-2">View</span> */}
                          <div
                            outline
                            color="primary"
                            size="xs"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Add new Sub Menu"
                          >
                            <Icon name="plus"></Icon>
                            <span> Add Sub </span>
                          </div>
                        </DropdownItem>
                      </li>
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
          </DataTableRow>
        </DataTableItem>

        {hasChildren && isExpanded && item.subcategory.map((child) => renderRow(child, level + 1))}
      </>
    );
  };

  return (
    <div>
      <BlockHead className="mb-3" size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle>{title}</BlockTitle>
          </BlockHeadContent>

          <BlockHeadContent>
            <div className="nk-block-tools">
              <ul className="nk-block-tools g-3 align-items-center">
                <li>
                  <div className="form-control-wrap d-flex align-items-center">
                    <div className="form-icon form-icon-right">
                      <Icon name="search"></Icon>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Search by  ${searchKeys.join(", ")}`}
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ minWidth: "250px" }}
                    />
                  </div>
                </li>
                {addButton && (
                  <li>
                    <Button
                      color="primary"
                      outline
                      className={`me-n1 bg-primary text-white`}
                      onClick={() => {
                        if (toggleCanvas) toggleCanvas();
                        else setIsOpen(!isOpen);
                        resetF();
                      }}
                    >
                      <Icon name={isOpen ? "minus" : "plus"} />
                    </Button>
                  </li>
                )}
              </ul>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>

      <Block className="table-wrapper" style={{ background: "white", borderRadius: "10px" }}>
        <div className="row nk-tb-list is-medium mb-3" style={{ background: "white" }}>
          <DataTableHead style={{ borderBottom: "1px solid #e5e9f2", fontWeight: "700" }}>
            {columns.map((col) => (
              <DataTableRow key={col.key}>
                <span className="sub-text" style={{ fontWeight: "700", fontSize: "14px" }}>
                  {col.label}
                </span>
              </DataTableRow>
            ))}

            <DataTableRow className="text-center">
              <span className="sub-text fw-bold">Status</span>
            </DataTableRow>

            <DataTableRow className="text-center">
              <span className="sub-text fw-bold">Actions</span>
            </DataTableRow>
          </DataTableHead>

          {isLoading ? (
            <>
              <MyLoader />
            </>
          ) : (
            <>
              {currentItems.length > 0 ? (
                currentItems.map((item) => renderRow(item))
              ) : (
                <div className="d-flex justify-content-end align-items-center py-5">
                  <span>No records found</span>
                </div>
              )}
            </>
          )}
          {!isLoading && filteredData.length > 0 && (
            <PreviewAltCard className="border-top">
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={filteredData.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </PreviewAltCard>
          )}

          <style>{`
            .hover-row {
              transition: background 0.2s ease;
            }
            .hover-row:hover {  
              background: #f8f9fc;
            }
            .hover-row .edit-icon {
              opacity: 0;
              transition: opacity 0.2s ease;
            }
            .hover-row:hover .edit-icon {
              opacity: 1;
            }
            .nk-tb-list .nk-tb-item {
              border-bottom: 1px solid #f0f0f0;
            }
            .nk-tb-list .nk-tb-item:last-child {
              border-bottom: none;
            }
          `}</style>
        </div>
      </Block>
    </div>
  );
};

export default SubCategoryTable;

// import React, { useState, useMemo } from "react";
// import {
//   Block,
//   BlockBetween,
//   BlockHead,
//   BlockHeadContent,
//   BlockTitle,
//   DataTableHead,
//   DataTableItem,
//   DataTableRow,
//   Icon,
//   PaginationComponent,
//   PreviewAltCard,
//   TooltipComponent,
// } from "../../../components/Component";
// import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
// import { Link } from "react-router-dom";

// const SubCategoryTable = ({
//   publicButton,
//   nameColumn,
//   handleImageOpenPreview,
//   resetF,
//   isOpen,
//   setIsOpen,
//   title = "Data Table",
//   data = [],
//   columns = [],
//   onEditClick,
//   selectorCheck,
//   onSelectChange,
//   searchKeys,
//   statusFilterEnabled = false,
//   addButton = true,
//   imageBaseURL = "",
//   handleToggleStatus,
//   toggleCanvas,
//   handleTogglePublish,
//   handleSubCategoryClick,
//   isLoading,
// }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemPerPage] = useState(25);
// console.log("table loading",isLoading)
//   const [searchText, setSearchText] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");

//   const [expandedRows, setExpandedRows] = useState({});

//   const toggleExpand = (id) => {
//     setExpandedRows((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   const filteredData = useMemo(() => {
//     let filtered = data;

//     if (searchText.trim() !== "" && searchKeys.length > 0) {
//       filtered = filtered.filter((item) =>
//         searchKeys
//           .map((key) => item[key])
//           .join(" ")
//           .toLowerCase()
//           .includes(searchText.toLowerCase())
//       );
//     }

//     if (statusFilterEnabled) {
//       if (statusFilter === "active") filtered = filtered.filter((i) => i.status === true);
//       else if (statusFilter === "inactive") filtered = filtered.filter((i) => i.status === false);
//     }

//     return filtered;
//   }, [data, searchText, statusFilter]);

//   const indexOfLastItem = currentPage * itemPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemPerPage;
//   const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const renderRow = (item, level = 0) => {
//     const hasChildren = item.subcategory && item.subcategory.length > 0;
//     const isExpanded = expandedRows[item.id];

//     return (
//       <>
//         <DataTableItem key={item.id} className="hover-row align-middle">
//           {columns.map((col, index) => {
//             const getValue = (obj, path) => path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);

//             const value = getValue(item, col.key);

//             return (
//               <DataTableRow key={col.key}>
//                 {index === 0 ? (
//                   <div
//                     className="d-flex align-items-center gap-2"
//                     // style={{ paddingLeft: `${level * 20}px` }}
//                   >
//                     {hasChildren ? (
//                       <Icon
//                         name={isExpanded ? "caret-down" : "caret-right"}
//                         style={{ cursor: "pointer" }}
//                         onClick={() => toggleExpand(item.id)}
//                       />
//                     ) : (
//                       <Icon name="dot" />
//                     )}

//                     {col.type === "image" && (
//                       <img
//                         src={`${imageBaseURL}${value}`}
//                         onClick={() => handleImageOpenPreview(`${imageBaseURL}${value}`)}
//                         alt="img"
//                         style={{
//                           width: "45px",
//                           height: "45px",
//                           borderRadius: "50%",
//                           objectFit: "cover",
//                           cursor: "pointer",
//                         }}
//                       />
//                     )}
//                     {nameColumn && (
//                       <span
//                         style={{
//                           fontWeight: "700",
//                           fontSize: "14px",
//                           color: "#364a63",
//                           textTransform: "capitalize",
//                         }}
//                       >
//                         {item[nameColumn]}
//                       </span>
//                     )}
//                   </div>
//                 ) : (
//                   <span style={{ fontWeight: "450" }}>{value || "-"}</span>
//                 )}
//               </DataTableRow>
//             );
//           })}
//           <DataTableRow className="text-center">
//             <span
//               onClick={() => handleToggleStatus(item)}
//               className={`fw-700 ${item.status ? "text-success" : "text-danger"}`}
//               style={{ cursor: "pointer", textTransform: "capitalize" }}
//             >
//               {item.status ? "Active" : "Inactive"}
//             </span>
//             {publicButton && (
//               <Button
//                 outline
//                 color={item?.isPublish ? `warning` : `success`}
//                 size={`xs`}
//                 className={`mx-1`}
//                 onClick={() => handleTogglePublish(item)}
//               >
//                 <Icon name={item?.isPublish ? "inbox-in" : "inbox-out"}></Icon>
//               </Button>
//             )}
//           </DataTableRow>
//           <DataTableRow className="text-center">
//             <ul className="nk-tb-actions gx-1 justify-content-center">
//               <li
//                 onClick={() => {
//                   onEditClick(item);
//                 }}
//                 className="edit-icon"
//               >
//                 <TooltipComponent
//                   tag="a"
//                   containerClassName="btn btn-icon btn-trigger btn-tooltip"
//                   id={"edit" + item.id}
//                   icon="edit-alt"
//                   direction="top"
//                   text="Edit"
//                   onClick={toggleCanvas}
//                 />
//               </li>
//               <li>
//                 <UncontrolledDropdown>
//                   <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
//                     <Icon name="more-h"></Icon>
//                   </DropdownToggle>

//                   <DropdownMenu end>
//                     <ul className="link-list-opt no-bdr">
//                       <li onClick={() => onEditClick(item)}>
//                         <DropdownItem tag="a" href="#edit" onClick={(ev) => ev.preventDefault()}>
//                           <Icon name="edit"></Icon>
//                           <span>Edit</span>
//                         </DropdownItem>
//                       </li>

//                       <li onClick={() => handleSubCategoryClick(item)}>
//                         <DropdownItem>
//                           {/* <Icon name="eye" />
//                           <span className="ms-2">View</span> */}
//                           <div
//                             outline
//                             color="primary"
//                             size="xs"
//                             data-toggle="tooltip"
//                             data-placement="top"
//                             title="Add new Sub Menu"
//                           >
//                             <Icon name="plus"></Icon>
//                             <span> Add Sub </span>
//                           </div>
//                         </DropdownItem>
//                       </li>
//                     </ul>
//                   </DropdownMenu>
//                 </UncontrolledDropdown>
//               </li>
//             </ul>
//           </DataTableRow>
//         </DataTableItem>

//         {hasChildren && isExpanded && item.subcategory.map((child) => renderRow(child, level + 1))}
//       </>
//     );
//   };

//   return (
//     <div>
//       <BlockHead className="mb-3" size="sm">
//         <BlockBetween>
//           <BlockHeadContent>
//             <BlockTitle>{title}</BlockTitle>
//           </BlockHeadContent>

//           <BlockHeadContent>
//             <div className="nk-block-tools">
//               <ul className="nk-block-tools g-3 align-items-center">
//                 <li>
//                   <div className="form-control-wrap d-flex align-items-center">
//                     <div className="form-icon form-icon-right">
//                       <Icon name="search"></Icon>
//                     </div>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder={`Search by  ${searchKeys.join(", ")}`}
//                       value={searchText}
//                       onChange={(e) => {
//                         setSearchText(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                       style={{ minWidth: "250px" }}
//                     />
//                   </div>
//                 </li>
//                 {addButton && (
//                   <li>
//                     <Button
//                       color="primary"
//                       outline
//                       className={`me-n1 bg-primary text-white`}
//                       onClick={() => {
//                         if (toggleCanvas) toggleCanvas();
//                         else setIsOpen(!isOpen);
//                         resetF();
//                       }}
//                     >
//                       <Icon name={isOpen ? "minus" : "plus"} />
//                     </Button>
//                   </li>
//                 )}
//               </ul>
//             </div>
//           </BlockHeadContent>
//         </BlockBetween>
//       </BlockHead>

//       <Block className="table-wrapper" style={{ background: "white", borderRadius: "10px" }}>
//         <div className="row nk-tb-list is-medium mb-3" style={{ background: "white" }}>
//           <DataTableHead style={{ borderBottom: "1px solid #e5e9f2", fontWeight: "700" }}>
//             {columns.map((col) => (
//               <DataTableRow key={col.key}>
//                 <span className="sub-text" style={{ fontWeight: "700", fontSize: "14px" }}>
//                   {col.label}
//                 </span>
//               </DataTableRow>
//             ))}

//             <DataTableRow className="text-center">
//               <span className="sub-text fw-bold">Status</span>
//             </DataTableRow>

//             <DataTableRow className="text-center">
//               <span className="sub-text fw-bold">Actions</span>
//             </DataTableRow>
//           </DataTableHead>

//           {currentItems.length > 0 ? (
//             currentItems.map((item) => renderRow(item))
//           ) : (
//             <div className="d-flex justify-content-end align-items-center py-5">
//               <span>No records found</span>
//             </div>
//           )}

//           {filteredData?.length > 0 && (
//             <PreviewAltCard className="border-top">
//               <PaginationComponent
//                 itemPerPage={itemPerPage}
//                 totalItems={filteredData.length}
//                 paginate={paginate}
//                 currentPage={currentPage}
//               />
//             </PreviewAltCard>
//           )}

//           <style>{`
//             .hover-row {
//               transition: background 0.2s ease;
//             }
//             .hover-row:hover {
//               background: #f8f9fc;
//             }
//             .hover-row .edit-icon {
//               opacity: 0;
//               transition: opacity 0.2s ease;
//             }
//             .hover-row:hover .edit-icon {
//               opacity: 1;
//             }
//             .nk-tb-list .nk-tb-item {
//               border-bottom: 1px solid #f0f0f0;
//             }
//             .nk-tb-list .nk-tb-item:last-child {
//               border-bottom: none;
//             }
//           `}</style>
//         </div>
//       </Block>
//     </div>
//   );
// };

// export default SubCategoryTable;
